import React from "react";
import style from "./index.module.scss";

function Join2(props) {

  const join = () => {
    window.gtag("event", "pc_home_join_bottom");
    props.join();
  };

  return (
    <section>
      <div className={`${style.join2_box} ${!props.active ? style.active : ""}`}>
        <p className={style.join2_title} dangerouslySetInnerHTML={{__html: props.langState.homeData.helpText3}}></p>
        <div className={style.pets}  onClick={join}>
          <div className={style.join_btn}>{props.langState.homeData.joinBtn} &gt;</div>
        </div>
        <div className={style.fireworks_left}></div>
        <div className={style.fireworks_right}></div>
      </div>
      {/* <div className={style.tip_box}>
        <p>Perks are not guaranteed</p>
        <p>Art asset provided can be adjusted before the official release</p>
        <p>The final interpretation right of the platform belongs to the official</p>
      </div> */}
    </section>
  );
}

export default Join2;
